import _URL from '../../URL/index';
const axios = _URL.axios;


export default {
    services: {
        fetchScheduledFlights: (flightNumber, date, token = '') => {
            return axios(token).get(`/flights/${date}/${flightNumber}`);
        },
        getFlightsInformationByIdent: (ident, token = "") => {
            return axios(token).get(`/flights-information/${ident}`);
        }
    }
}